import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import TablePagination from '@material-ui/core/TablePagination';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

import SearchIcon from '@material-ui/icons/Search';
import AccountIcon from '@material-ui/icons/AccountCircle';

import Skeleton from '@material-ui/lab/Skeleton';

import PurchaseTicketDialog from 'app/components/accounting/payments/PurchaseTicketDialog';
import ViewUserDialog from 'app/components/user/ViewUserDialog';

const useStyles = makeStyles(theme => ({
    titleBox: {
        paddingTop: '60px',
        paddingBottom: '60px',
        paddingRight: '20px',
        paddingLeft: '20px',
        textAlign: 'center',
        backgroundImage: 'url("/images/german-club-grey.png")',
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    emptyCon: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingRight: '20px',
        paddingLeft: '20px',
        textAlign: 'center'
    },
}));

export default function Events(props) {

    const [ guests, setGuests ] = useState([]);
    const [ filteredGuests, setFilteredGuests ] = useState([]);

    const [ userDialogId, setUserDialogId ] = useState(false);
    const [ viewUserDialogOpen, setViewUserDialogOpen ] = useState(false);

    const [ searchValue, setSearchValue ] = useState("");
    const [ rowsPerPage, setRowsPerPage ] = useState(5);
    const [ page, setPage ] = useState(0);

    const [ loading, setLoading ] = useState(true);

    const classes = useStyles();

    // Getter Functions ------------------------------------------

    const getGuests = () => {
        setLoading(true);

        api.get('/guest')
            .then(res => {
                const newGuests = res.guests;
                setGuests(newGuests);
                setFilteredGuests(newGuests);
            }).catch( error => {
                console.log(error.response);
            }).then(() => {
                setLoading(false);
            });
    }

    const trackPage = () => {
        api.get('/track/guests');
    }

    useEffect(() => {
        getGuests();
        trackPage();
    }, []);

    // Setter Functions ------------------------------------------


    const handleChangePage = (event, page) => {
        setPage(page);
    };

    const handleSearchValue = event => {
        event.preventDefault();

        const newSearchValue = event.target.value

        let newFilteredGuests = guests.filter((d) => {
            let match = false;
            if (d.full_name !== null) {
                let m = d.full_name.toLowerCase().includes(newSearchValue.toLowerCase());
                if (m) match = true;
            }
            return match;
        })

        setFilteredGuests(newFilteredGuests);
        setSearchValue(newSearchValue);
    };

    // Invite Guest Dialog Functions ------------------------------------------

    const openViewUserDialog = id => {
        setUserDialogId(id);
        setViewUserDialogOpen(true);
    }

    const closeViewUserDialog = () => {
        setViewUserDialogOpen(false);
    }

    const closedViewUserDialog = () => {
        setUserDialogId(0);
    }

    // Rendering Functions ------------------------------------------

    const SkeletonList = () => {
        let rows = [];

        for (let i = 1; i <= rowsPerPage; i++) {
            rows.push(
                <ListItem key={i}>
                    <ListItemAvatar>
                        <Skeleton variant="circle" height={40} width={40}/>
                    </ListItemAvatar>
                    <ListItemText
                        disableTypography
                        primary={<Skeleton variant="text" height={6} width="40%"/>}
                        secondary={<Skeleton variant="text" height={4} width="20%"/>}
                    />
                </ListItem>
            )
        };

        return rows;
    }

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredGuests.length - page * rowsPerPage);

    return (

        <div className="container app-container">
            <div className={classes.titleBox}>
                <Typography variant="h4" component="h2">
                    Guestbook
                </Typography>
            </div>
            <Grid container justify="center">
                <Grid item xs={12} sm={8} md={6}>
                    {loading ? (
                        <Paper className={classes.paper}>
                            <form autoComplete="off">
                                <input autoComplete="false" name="hidden" type="text" style={{ display: 'none' }}/>
                                <TextField
                                    id="users-search"
                                    label="Search Guests"
                                    type="search"
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    onChange={handleSearchValue}
                                />
                                <List dense className={classes.list}>
                                    <SkeletonList/>
                                </List>
                                <TablePagination
                                    component="div"
                                    count={filteredGuests.length}
                                    rowsPerPage={rowsPerPage}
                                    rowsPerPageOptions={[rowsPerPage]}
                                    page={page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    onChangePage={handleChangePage}
                                />
                            </form>
                        </Paper>
                    ) : (guests.length == 0) ? (
                        <div className={classes.emptyCon}>
                            <Typography
                                component="h3"
                                color="textSecondary"
                                variant="h6"
                                gutterBottom
                                >
                                You do not have any guests.<br/>Create guests by inviting family and friends to events.
                            </Typography>
                            <div className="p-xl"></div>
                            <Typography
                                component="div"
                                variant="subtitle2"
                                >
                                <Link to="/events">
                                    View Events
                                </Link>
                            </Typography>
                        </div>
                    ) : (
                        <Paper className={classes.paper}>
                            <form autoComplete="off">
                                <input autoComplete="false" name="hidden" type="text" style={{ display: 'none' }}/>
                                <TextField
                                    id="users-search"
                                    label="Search Guests"
                                    type="search"
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth
                                    onChange={handleSearchValue}
                                />
                                <List dense className={classes.root}>
                                    {filteredGuests.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(u => (
                                        <ListItem
                                            key={u.id}
                                            button
                                            onClick={() => openViewUserDialog(u.id)}
                                            selected = {(userDialogId === u.id)}>
                                            <ListItemAvatar>
                                                <Avatar
                                                    alt={u.full_name}
                                                    src={u.image_url }
                                                    >
                                                    <AccountIcon fontSize='inherit' />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={u.full_name}
                                                secondary={u.public_membership_title}/>
                                        </ListItem>
                                    ))}
                                    {emptyRows > 0 && (
                                        <ListItem style={{ height: 48 * emptyRows }}/>
                                    )}
                                </List>
                                <TablePagination
                                    component="div"
                                    count={filteredGuests.length}
                                    rowsPerPage={rowsPerPage}
                                    rowsPerPageOptions={[rowsPerPage]}
                                    page={page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    onChangePage={handleChangePage}
                                />
                            </form>
                        </Paper>
                    )}
                </Grid>
            </Grid>
            <ViewUserDialog
                id={userDialogId}
                open={viewUserDialogOpen}
                onClose={closeViewUserDialog}
                onClosed={closedViewUserDialog}
            />
        </div>
    )
}
